<template>
  <AIVDialog
    :visible="visible"
    title="Confirm Client"
    width="500px"
    height="auto"
    @update:visible="$emit('update:visible', $event)"
  >
    <div class="confirm-client-content">
      <p class="confirm-message">
        No exact client match found for "<strong>{{ clientName }}</strong>". Did
        you mean one of these?
      </p>
      <div class="matches-list">
        <div
          v-for="client in matches"
          :key="client.id"
          class="match-item"
        >
          <div class="match-info">
            <span class="match-name">
              {{ client.first_name }} {{ client.last_name }}
            </span>
            <span v-if="client.vr_client_id" class="match-id">
              VR ID: {{ client.vr_client_id }}
            </span>
            <span v-if="client.dspd_pid" class="match-id">
              DSPD PID: {{ client.dspd_pid }}
            </span>
            <span v-if="client.payer_type" class="match-payer">
              {{ client.payer_type }}
            </span>
          </div>
          <el-button
            size="small"
            type="primary"
            @click="$emit('select-client', client)"
          >
            Select
          </el-button>
        </div>
      </div>
    </div>
    <template slot="footer">
      <div class="confirm-footer">
        <el-button round @click="$emit('cancel')">Cancel</el-button>
        <el-button type="warning" round @click="$emit('confirm-new')">
          Create New Client
        </el-button>
      </div>
    </template>
  </AIVDialog>
</template>

<script>
export default {
  name: "ConfirmNewClientModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    clientName: {
      type: String,
      default: "",
    },
    matches: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.confirm-client-content {
  padding: 20px;
}

.confirm-message {
  margin-bottom: 16px;
  font-size: 14px;
  color: #e0e0e0;
}

.matches-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
}

.match-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: rgba(37, 55, 65, 0.4);
  border: 1px solid rgba(66, 98, 116, 0.5);
  border-radius: 4px;
}

.match-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.match-name {
  font-weight: 600;
  color: #e0e0e0;
  font-size: 14px;
}

.match-id {
  font-size: 12px;
  color: #b0b0b0;
}

.match-payer {
  font-size: 11px;
  color: #8a8a8a;
  text-transform: uppercase;
}

.confirm-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}
</style>
